import { BotIdentificator } from '@common/model/bot';
import { MemberUser } from '@youhelp-ru/core';

export const SUPPORT_BOT = MemberUser.bot(BotIdentificator.SupportBot);

export const SUPPORT_DIALOG_QUERY = {
  as: SUPPORT_BOT,
  isInitiator: true,
} as const;
